// import "../src/dist/styles.css";
import "./styles/styles.scss";
import About from "./pages/About";
import Home from "./pages/Home";
import { Route, Routes } from "react-router-dom";
import Models from "./pages/Models";
import TestimonialsPage from "./pages/TestimonialsPage";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import SelectVehicle from "./pages/SelectVehicle";
import DetailVehicle from "./pages/DetailVehicle";
import Notiflix from "notiflix";
import SelectPaymentMethod from "./pages/SelectPaymentMethod";
import Ewallet from "./pages/Ewallet";
import FaqPage from "./pages/FaqPage";
import WhyChooseUs from "./pages/WhyChooseUs";
// import CustomerFormPage from "./pages/CustomerFormPage";
import CustomerFormPage2 from "./pages/CustomerFormPage2";
import BookingDetail from "./pages/BookingDetail";
import ManageBooking from "./pages/ManageBooking";
import SelectVehicle2 from "./pages/SelectVehicle2";

function App() {
  Notiflix.Loading.init({ zindex: 9999999999991 });
  Notiflix.Notify.init({ zindex: 9999999999992 });

  return (
    <>
      <Routes>
        <Route index path="/" element={<Home />} />
        <Route path="about-us" element={<About />} />
        <Route path="vehicles" element={<Models />} />
        {/* <Route path="select-vehicle" element={<SelectVehicle />} /> */}
        <Route path="select-vehicle" element={<SelectVehicle2 />} />
        {/* <Route path="customer-form" element={<CustomerFormPage />} /> */}
        <Route path="manage-booking" element={<ManageBooking />} />
        <Route path="booking/:bookingCode" element={<BookingDetail />} />
        <Route path="customer-form" element={<CustomerFormPage2 />} />
        <Route path="detail-vehicle" element={<DetailVehicle />} />
        <Route path="testimonials" element={<TestimonialsPage />} />
        <Route path="team" element={<Team />} />
        <Route path="contact" element={<Contact />} />
        <Route path="select-payment-method" element={<SelectPaymentMethod />} />
        <Route path="e-wallet" element={<Ewallet />} />
        <Route path="faq" element={<FaqPage />} />
        <Route path="why-choose-us" element={<WhyChooseUs />} />
      </Routes>
    </>
  );
}

export default App;
